<template>
  <div class="h-header">
    <div class="h-header-container">
      <div class="h-logo">
        <a href="/">养老机构服务信用评价平台</a>
      </div>

      <div v-if="!username" class="h-account">
        <router-link class="h-login" to="/login">我爱社区智慧养老系统</router-link>
        <div class="h-separate"></div>
        <router-link class="h-login" to="/login">登录</router-link>
        <div class="h-separate"></div>
        <!--        <router-link class="h-login" to="/register">注册</router-link>-->
        <!--        <a href="javascript:void(0);" target="_blank" class="h-login" onclick="registerSelect(this)" title="注册">注册</a>-->
        <a href="javascript:void(0);" class="h-login" @click="registerSelect(this)">注册</a>
      </div>
      <div v-else class="h-account">
        <a href="javascript:void(0);" class="h-login" @click="loginOrgCare(this)">我爱社区智慧养老系统</a>
        <div class="h-separate"></div>
        <el-dropdown trigger="click" @visible-change="changeIcon" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ username }}
            <i v-if="down" class="el-icon-arrow-down el-icon--right"/>
            <i v-else class="el-icon-arrow-up el-icon--right"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">修改密码</el-dropdown-item>
            <el-dropdown-item command="b">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <logout :openLogout="openLogout" @reset="reset" @logout="logout"/>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import {getCareLink, isLogin} from "../../api/login";

export default {
  name: 'myHeader',
  data() {
    return {
      centerDialogVisible: false,
      down: true,
      openLogout: false,
      username: ""
    }
  },
  mounted() {
    this.timer = null
    clearInterval(this.timer)
    this.timer = setInterval(() => {
      this.getCookie();
      // this.$router.go() //路由刷新
    }, 300000)
  },
  created() {
    this.getCookie();
  },
  methods: {
    getCookie() {
      isLogin().then(res => {
        // alert(res.data)
        if (!res.data) {
          Cookies.clear();
        }
        this.username = Cookies.get("username") || "";
      });
    },
    // 切换上下箭头图标
    changeIcon() {
      this.down = !this.down
    },
    // 点击下拉菜单
    handleCommand(command) {
      if (command === 'a') {
        this.$router.push('/resetPassword')
      } else {
        this.openLogout = true
      }
    },
    // 关闭窗口
    reset() {
      this.openLogout = false
    },
    // 退出登录
    logout() {
      this.openLogout = false
      this.username = null
      Cookies.remove("username")
      Cookies.remove("uuid")
      Cookies.remove("token")
      this.$message.success("账号已退出")
      location.href = "/"
    },
    loginOrgCare() {
      getCareLink().then(res => {
        const w = window.open("about:blank")
        w.location.href = res.msg;
      });
    },
    registerSelect() {
      this.$confirm('请选择注册身份', '提示', {
        confirmButtonText: '企     业',
        cancelButtonText: '个    人',
        customClass: 'customConfirm',
        // confirmButtonClass: 'btnCancel',
        cancelButtonClass: 'el-button--primary',
        distinguishCancelAndClose: true,
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.$router.push({path: "/register"}).catch(() => {
            });
          } else if (action === 'cancel') {
            this.$router.push({path: "/registerPerson"}).catch(() => {
            });
          }
        }
      });
    }
  }

}
</script>
<style>
.customConfirm .el-message-box__btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped>
.h-header {
  width: 100%;
  height: 100px;
  color: rgba(51, 51, 51, 1);
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}

.h-header-container {
  width: 1140px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.h-logo {
  margin-top: 44px;
  width: 336px;
  height: 33px;
  font-size: 28px;
  font-weight: 700;
}

.h-account {
  margin-top: 50px;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 310px;
  height: 16px;
}

.h-login {
  margin-right: 10px;
}

.h-separate {
  width: 0px;
  height: 14px;
  opacity: 1;
  background: rgba(204, 204, 204, 1);
  border: 1px solid rgba(166, 166, 166, 1);
  margin-right: 10px;
}

.el-dropdown-link {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.el-icon-arrow-down {
  font-size: 14px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue